export default "__VITE_ASSET__D$B_xfqD__"